import { render, staticRenderFns } from "./CurrentTag.vue?vue&type=template&id=cff9afa0&scoped=true&"
import script from "./CurrentTag.vue?vue&type=script&lang=js&"
export * from "./CurrentTag.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTag.vue?vue&type=style&index=0&id=cff9afa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff9afa0",
  null
  
)

export default component.exports